@if (userRoleView) {
  <div class="main-container">
    @if (!isAddRole) {
      <div [formGroup]="addRoleForm">
        <div class="page-header">
          <div class="routing-buttons">
            <div
              class="action-button back-button"
              (click)="navigateBack()"
              tabindex="0"
              (keydown.enter)="navigateBack()"
            >
              <mat-icon class="icon back-icon">arrow_back</mat-icon>
            </div>
            <div
              class="action-button reload-button"
              (click)="ngOnInit()"
              tabindex="0"
              (keydown.enter)="ngOnInit()"
            >
              <mat-icon class="icon reload-icon">refresh</mat-icon>
            </div>
          </div>
          <span class="page-title">Role Management</span>
          <div class="button-group">
            @if (userRoleCreate) {
              <button class="primary-button" (click)="addRole('add', null)">
                Add Role <mat-icon class="btn-icon">open_in_new</mat-icon>
              </button>
            }
          </div>
        </div>
        <div class="component-container">
          <!-- Component Header Section -->
          <div class="component-header">
            <h6 class="component-title">Role List</h6>
            <div class="component-actions">
              <app-common-search
                (searchSubmit)="onSearchRolename($event)"
              ></app-common-search>
            </div>
          </div>
          <!-- Separator between Header and Body -->
          <div class="component-separator"></div>
          <!-- Component Body Section -->
          <div class="component-body">
            <table>
              <thead>
                <tr>
                  <th>Role Name</th>
                  <th>Role Type</th>
                  <th>Hierarchy Level</th>
                  <th>Date</th>
                  <th>Action</th>
                </tr>
              </thead>
              @if (listOfRole.length > 0) {
                <tbody>
                  @for (item of listOfRole; track item) {
                    <tr>
                      <td>
                        {{ item.userRole }}
                      </td>
                      <td>
                        {{ item.roleType }}
                      </td>
                      <td>
                        {{ item.hierarchyLevel }}
                      </td>
                      <td>
                        {{ item.createdAt }}
                      </td>
                      <td>
                        <div class="action-buttons">
                          <button
                            class="primary-button view-button"
                            (click)="fetchDataById(item.roleId)"
                          >
                            <mat-icon class="btn-icon">visibility</mat-icon>
                          </button>
                          @if (userRoleDelete) {
                            <button
                              class="primary-button delete-button"
                              (click)="deleteRole(item.roleId)"
                            >
                              <mat-icon class="btn-icon">delete</mat-icon>
                            </button>
                          }
                        </div>
                      </td>
                    </tr>
                  }
                </tbody>
              }
              @if (listOfRole.length === 0) {
                <tbody>
                  <tr>
                    <td colspan="12">
                      <img
                        loading="lazy"
                        class="no-data-img"
                        src="../../assets/dataNotFound.jpg"
                        alt="No Data Found"
                      />
                    </td>
                  </tr>
                </tbody>
              }
            </table>
          </div>
          <div class="component-footer">
            @if (listOfRole.length > 0) {
              <app-common-component-pagination
                [totalItems]="totalItems"
                [pageSize]="pageSize"
                [currentPage]="pageNo"
                (pageChange)="onPageChange($event)"
                (sizeChange)="onSizeChange($event)"
              >
              </app-common-component-pagination>
            }
          </div>
        </div>
      </div>
    }

    @if (isAddRole) {
      <div>
        <form [formGroup]="addRoleForm" novalidate>
          <!-- Component Header Section -->
          <div class="page-header">
            <div class="routing-buttons">
              <div
                class="action-button back-button"
                (click)="changePage()"
                tabindex="0"
                (keydown.enter)="changePage()"
              >
                <mat-icon class="icon back-icon">arrow_back</mat-icon>
              </div>
              <div
                class="action-button reload-button"
                (click)="onClickAddRoleRefresh()"
                tabindex="0"
                (keydown.enter)="onClickAddRoleRefresh()"
              >
                <mat-icon class="icon reload-icon">refresh</mat-icon>
              </div>
            </div>
            <span class="page-title">Role Management</span>
          </div>
          <!-- Component Body Section -->
          <div class="component-container">
            <div class="component-header">
              @if (submitButton) {
                <h6 class="component-title">Add New Role</h6>
              }
              @if (updateButton) {
                <h6 class="component-title">Update Role</h6>
              }
              <div class="component-actions"></div>
            </div>
            <!-- Separator between Header and Body -->
            <div class="component-separator"></div>
            <div class="component-body">
              <div class="form-section">
                <div class="form-group">
                  <label for="" class="form-label">Role Name</label>
                  <mat-form-field appearance="outline">
                    <mat-label>Role Name</mat-label>
                    @if (submitButton) {
                      <input
                        matInput
                        formControlName="userRole"
                        placeholder="Role Name"
                        required
                      />
                    }
                    @if (updateButton) {
                      <input
                        matInput
                        formControlName="userRole"
                        placeholder="Role Name"
                        required
                        readonly
                      />
                    }
                    @if (
                      addRoleForm.controls['userRole'].touched &&
                      addRoleForm.controls['userRole'].errors?.['required']
                    ) {
                      <mat-error class="text-danger">
                        This field is mandatory.
                      </mat-error>
                    }
                    @if (
                      addRoleForm.controls['userRole'].touched &&
                      addRoleForm.controls['userRole'].errors?.['pattern']
                    ) {
                      <mat-error class="text-danger">
                        Please enter a valid User Role.
                      </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="form-group">
                  <label for="" class="form-label">Role Type</label>
                  <mat-form-field appearance="outline">
                    <mat-label>Role Type</mat-label>
                    <mat-select
                      formControlName="roleType"
                      (selectionChange)="onRoleTypeChange($event)"
                    >
                      @for (role of roleTypeList; track role) {
                        <mat-option [value]="role.value">
                          {{ role.name }}
                        </mat-option>
                      }
                    </mat-select>
                    @if (
                      addRoleForm.controls['roleType'].touched &&
                      addRoleForm.controls['roleType'].errors?.['required']
                    ) {
                      <mat-error> This field is mandatory. </mat-error>
                    }
                  </mat-form-field>
                </div>
                @if (viewRoleGroup) {
                  <div class="form-group">
                    <label for="" class="form-label">Role Group</label>
                    <mat-form-field appearance="outline">
                      <mat-label>Role Group</mat-label>
                      <mat-select formControlName="roleGroup">
                        @for (role of roleGroupList; track role) {
                          <mat-option [value]="role.id">
                            {{ role.groupName }}
                          </mat-option>
                        }
                      </mat-select>
                      @if (
                        addRoleForm.controls['roleGroup'].touched &&
                        addRoleForm.controls['roleGroup'].invalid
                      ) {
                        <mat-error> This field is mandatory. </mat-error>
                      }
                    </mat-form-field>
                  </div>
                }
              </div>
              <div class="component-container">
                <div class="component-subheader">
                  <h6 class="component-title">Select Permission</h6>
                </div>
                <div class="component-separator"></div>
                <div class="component-body">
                  <table>
                    <tr>
                      <th>Pages</th>
                      <th>
                        Select All
                        <mat-checkbox (change)="onSelectAllPagesChange($event)">
                        </mat-checkbox>
                      </th>
                      <th>
                        View
                        <mat-checkbox
                          (change)="onSelectViewPagesChange($event)"
                        >
                        </mat-checkbox>
                      </th>
                      <th>
                        Create
                        <mat-checkbox
                          (change)="onSelectCreatePagesChange($event)"
                        >
                        </mat-checkbox>
                      </th>
                      <th>
                        Update
                        <mat-checkbox
                          (change)="onSelectUpdatePagesChange($event)"
                        >
                        </mat-checkbox>
                      </th>
                      <th>
                        Delete
                        <mat-checkbox
                          (change)="onSelectDeletePagesChange($event)"
                        >
                        </mat-checkbox>
                      </th>
                    </tr>
                    <tbody>
                      @for (item of allPages; track item) {
                        <tr>
                          @if (item.level === 0) {
                            <td
                              class="text-start"
                              style="padding-left: 40px !important"
                            >
                              <strong>{{ item.pageName }}</strong>
                            </td>
                          }
                          @if (item.level > 0) {
                            <td
                              class="text-start"
                              style="padding-left: 80px !important"
                            >
                              {{ item.pageName }} {{ item.pare }}
                            </td>
                          }
                          <td>
                            <input
                              type="checkbox"
                              value="{{ item.pageName }}"
                              (change)="onSelectAllChange($event)"
                              id="{{ item.id }}"
                              [disabled]="item.isDisabled"
                              [checked]="item.selectAll"
                              class="mr-2"
                            />
                          </td>
                          <td>
                            <input
                              type="checkbox"
                              value="{{ item.pageName }}"
                              (change)="onCheckboxViewChange($event)"
                              [checked]="item.view"
                              [disabled]="item.isDisabled"
                              class="mr-2"
                            />
                          </td>
                          <td>
                            <input
                              type="checkbox"
                              [disabled]="!item.view"
                              value="{{ item.pageName }}"
                              id="{{ item.id }}"
                              (change)="onCheckboxCreateChange($event)"
                              [checked]="item.create"
                              class="mr-2"
                            />
                          </td>
                          <td>
                            <input
                              type="checkbox"
                              [disabled]="!item.view"
                              value="{{ item.pageName }}"
                              (change)="onCheckboxUpdateChange($event)"
                              [checked]="item.update"
                              class="mr-2"
                            />
                          </td>
                          <td>
                            <input
                              type="checkbox"
                              [disabled]="!item.view"
                              value="{{ item.pageName }}"
                              (change)="onCheckboxDeleteChange($event)"
                              [checked]="item.delete"
                              class="mr-2"
                            />
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="component-separator"></div>
            <div class="component-footer">
              <div class="button-group">
                @if (submitButton && userRoleCreate) {
                  <button class="submit-button" (click)="saveRole()">
                    Submit<mat-icon class="btn-icon">check_circle</mat-icon>
                  </button>
                }
                <!-- [disabled]="addRoleForm.invalid" -->
                @if (updateButton && userRoleUpdate) {
                  <button class="edit-button" (click)="updateRole()">
                    Update <mat-icon class="btn-icon">edit</mat-icon>
                  </button>
                }
              </div>
            </div>
          </div>
        </form>
      </div>
    }
  </div>
}
